import { useTranslation } from "@opendash/i18n";
import { stringToTag } from "@opendash/ui";
import { Card, Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { Message } from "../../../js/parsegenerated";
import { MessageControl } from "./MessageControl";
import { MessageTitle } from "./MessageTitle";

type Props = {
  messages: Message[];
};

export const CardView = observer((props: Props) => {
  const t = useTranslation();

  return (
    <Flex gap="small" vertical>
      {props.messages.map((entry, index) => {
        try {
          entry.data.translation.description ??= "";
        } catch (e) {
          console.error(
            "Not translation object found in message:",
            entry.id,
            e
          );
        }
        return (
          <Card
            key={index}
            size="small"
            title={<MessageTitle message={entry} />}
          >
            <Flex justify="space-between">
              <Typography.Text>
                {stringToTag(
                  t(entry.get("content"), entry.data?.translation)?.trim(),
                  "'"
                )}
              </Typography.Text>
              <MessageControl message={entry} />
            </Flex>
          </Card>
        );
      })}
    </Flex>
  );
});
